import React, { useState } from 'react';
import { Layout, message, Table, Tag, Popconfirm, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import TopHeader from '../TopHeader/TopHeader';
import VideoListForm from '../VideoList/videoLimitSettings';
import styles from '../VideoList/VideoListStyle.module.scss';
import BillingTable from '../common/BillingTable/BillingTable';
import { use } from 'react';
const BillingCycle = () => {
  const [domainData, setDomainData] = useState(null);
  const webData = JSON.parse(localStorage.getItem('subDomainData'));
  const billingData = domainData?.billingData || webData?.billingData || [];

  return (
    <Layout className={styles.homeLayout}>
      <div className="aside-right-top-bar all-customer-topbar">
        <div className="top-bar-left">
          <div className="top_bar">
            <h3>Billing Cycle</h3>
          </div>
        </div>
        <div className="top-bar-right">
          <TopHeader />
        </div>
      </div>
      <div className={styles.billingContainer}>
        <div className={styles.formSection}>
          <VideoListForm setDomainData={setDomainData} />
        </div>
        <div className={styles.tableSection}>
          <BillingTable data={billingData} />
        </div>
      </div>
    </Layout>
  );
};

export default BillingCycle;
